import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import * as LucideIcons from 'lucide-react';

const WhyUs = () => {
  const { t } = useLanguage();

  const getIcon = (iconName) => {
    const Icon = LucideIcons[iconName];
    return Icon ? <Icon className="w-8 h-8" /> : null;
  };

  return (
    <section id="about" className="relative py-20 lg:py-28 bg-[#0B2E4B] overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0">
        <svg className="absolute inset-0 w-full h-full opacity-10" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="whyus-hex" width="60" height="52" patternUnits="userSpaceOnUse">
              <polygon 
                points="30,0 60,15 60,45 30,60 0,45 0,15" 
                fill="none" 
                stroke="#28BBC5" 
                strokeWidth="0.5"
              />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#whyus-hex)" />
        </svg>
        <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-gradient-to-tl from-[#28BBC5]/15 to-transparent rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">
            {t.whyUs.title}
          </h2>
          <p className="text-lg text-white/70 max-w-2xl mx-auto">
            {t.whyUs.subtitle}
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {t.whyUs.items.map((item, index) => (
            <div
              key={item.id}
              className="group text-center p-8 bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl hover:bg-white/10 hover:border-[#28BBC5]/50 transition-all duration-400"
            >
              <div className="inline-flex items-center justify-center w-16 h-16 mb-6 rounded-xl bg-[#28BBC5]/20 text-[#28BBC5] group-hover:bg-[#28BBC5] group-hover:text-white transition-all duration-300">
                {getIcon(item.icon)}
              </div>
              <h3 className="text-xl font-semibold text-white mb-3 group-hover:text-[#28BBC5] transition-colors duration-300">
                {item.title}
              </h3>
              <p className="text-white/60 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
